export const BLOQUEIO_RESTITUICAO_DTO = [
    {
        "blppPgtoNr": 9012205400026256,
        "blppNrSq": 2,
        "blppDtRegistro": "2023-02-02T18:45:14.000+00:00",
        "blppVlReservado": 100,
        "blppDtReserva": "2023-02-02T18:45:14.000+00:00",
        "blppBUaCdAtualiza": null,
        "blppBNrTerminal": null,
        "blppBPfNrAtualiza": null,
        "blppBResBl": "CE2022140000027412022273001D0010000100001",
        "blppVlBloqueado": null,
        "blppDtBloqueio": null,
        "blppProcNr": null,
        "blppVlepPediUaCd": null,
        "blppVlepPediAnEx": null,
        "blppVlepPediNrSq": null,
        "blppVlepNrSq": null,
        "blppBPerdcomp": "181124230512122212246247",
        "blppDardPgtoNrIdAr": 9012205400026256,
        "blppDardNrSq": 1
    }
];